const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'https://smartbathroom.ir').replace(/\/+$/, '')

export function getCanonicalUrl(path = '/') {
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${SITE_URL}${cleanPath}`
}
